<template>
  <div class="detail-info description">
    <span class="info-title">操作：</span>
    <div class="">{{ showOperation }}</div>
  </div>

</template>

<script>
import { mapState } from "vuex";

export default {
  name: "DrugLook",
  computed: {
    ...mapState({
      patient: "showOrEditPatientInfo"
    }),
    showOperation() {
      return this.patient?.operationM;
    },
  },
};
</script>

<style scoped lang="scss">
.detail-info {
  display: flex;
}

.description {
  height: auto;
}

.info-title {
  width: 62px;
}

</style>
